<template>
  <v-app>
    <v-progress-circular v-show="loading"
                         indeterminate
                         color="primary"
    ></v-progress-circular>

    <div class="finatrade_wrapper">
      <div class="page page1">
        <div class="finatrade_header">
          <h1>合迪股份有限公司交易申請書</h1>
        </div>
        <!--header-->
        <div class="top">
          <div class="top-car">車種：機車</div>
          <!--top-car-->
          <div class="top-name">
            進件單位：
            <input type="text" />
          </div>
          <div class="top-date">
            申請日期：
            <!-- <input type="text" value="109" class="y"> -->
            <select v-model="editedItem.applyDate.year" class="y">
              <option v-for="year in yearList" :key="year.key" :value="year.key">{{year.name}}</option>
            </select>年
            <!-- <input type="text" value="07" class="m"> -->
            <select v-model="editedItem.applyDate.month" class="m">
              <option v-for="month in monthList" :key="month.key" :value="month.key">{{month.name}}</option>
            </select>月
            <!-- <input type="text" value="30" class="d"> -->
            <select v-model="editedItem.applyDate.day" class="d">
              <option v-for="day in dayList" :key="day.key" :value="day.key">{{day.name}}</option>
            </select>日
          </div>
        </div>
        <!--top-->
        <div class="area1">
          <div class="title1">
            申請
            <br />資訊
          </div>
          <table class="table1">
            <tr>
              <td rowspan="2" width="252px">
                <span class="tdTit tdTit1">金額：NT$</span>
                <div class="con1">
                  <input
                    type="text"
                    v-model="editedItem.vendor.totalPrice"
                    v-if="canCustomPrice"
                    class="text_c"
                    style="width:115px;"
                  />
                  <select
                    v-else
                    v-model="editedItem.vendor.totalPrice"
                    class="text_c"
                    style="width:115px;"
                    @change="changeInstallmentsNumber"
                  >
                    <option
                      v-for="price in getCreditPriceList"
                      :key="price"
                      :value="price"
                    >{{price}}</option>
                  </select>
                </div>
                <span class="tdTit tdTit2">元整</span>
              </td>
              <td class="tdEnd tdDot">
                <span class="tdTit tdTit3">專案名稱</span>
                <div class="con2">
                  <input v-model="editedItem.vendor.productName" type="text" style="width:350px;" />
                </div>
              </td>
            </tr>
            <tr>
              <td class="tdEnd">
                <span class="tdTit tdTit4">期數：</span>
                <div class="con3">
                  <input
                    type="text"
                    v-model="editedItem.vendor.installmentsNumber"
                    v-if="canCustomPrice"
                    style="width:58px;"
                    class="text_c"
                  />
                  <select
                    v-else
                    v-model="editedItem.vendor.installmentsNumber"
                    style="width:58px;"
                    class="text_c"
                    @change="changeInstallmentsNumber"
                  >
                    <option
                      v-for="number in getInstallmentsNumberList"
                      :key="number"
                      :value="number"
                    >{{number}}</option>
                  </select>
                </div>
                <span class="tdTit tdTit5">期</span>
                <span class="tdTit tdTit6">付款條件：</span>
                <div class="con4">
                  <span class="checkbox">
                    <input type="checkbox" />
                  </span>單月付
                  <span class="checkbox">
                    <input type="checkbox" />
                  </span>雙月付&nbsp;(&nbsp;期付款：NT$
                  <input
                    type="text"
                    v-model="editedItem.vendor.creditPriceMonth"
                    style="width:87px; margin:0 5px;"
                    class="text_c"
                  />元&nbsp;)
                  <span class="checkbox con4-1">
                    <input type="checkbox" />
                  </span>其他
                  <textarea></textarea>
                </div>
              </td>
            </tr>
          </table>
          <!--table1-->
          <div class="title2">
            付款
            <br />方式
          </div>
          <table class="table2">
            <tr>
              <td width="205px">
                <div class="con5">
                  <span class="checkbox">
                    <input type="checkbox" v-model="editedItem.paymentInfo.isBankBillPay" />
                  </span>銀行自動扣繳
                  <span class="checkbox">
                    <input type="checkbox" style="margin-left:-3px;" v-model="editedItem.paymentInfo.isPostBillPay" />
                  </span>郵局
                  <span class="checkbox">
                    <input type="checkbox" v-model="editedItem.paymentInfo.isAtmBillPay" />
                  </span>ATM
                  <span class="checkbox">
                    <input type="checkbox" v-model="editedItem.paymentInfo.isStoreBillPay" />
                  </span>超商
                  <span class="checkbox">
                    <input type="checkbox" v-model="editedItem.paymentInfo.isAutoBillPay" />
                  </span>ACH
                </div>
              </td>
              <td>
                <span class="tdTit tdTit7">繳款單寄送處：</span>
                <div class="con6">
                  <span class="checkbox">
                    <input
                      type="checkbox"
                      v-model="editedItem.paymentInfo.debitNote.isRegistration"
                    />
                  </span>戶籍地
                  <span class="checkbox">
                    <input
                      type="checkbox"
                      v-model="editedItem.paymentInfo.debitNote.isMailingAddress"
                    />
                  </span>通訊地
                  <span class="checkbox">
                    <input
                      type="checkbox"
                      v-model="editedItem.paymentInfo.debitNote.isCompanyAddress"
                    />
                  </span>公司
                  <span class="checkbox">
                    <input
                      type="checkbox"
                      v-model="editedItem.paymentInfo.debitNote.isOtherAddress"
                    />
                  </span>其他
                  <textarea v-model="editedItem.paymentInfo.debitNote.address"></textarea>
                </div>
              </td>
            </tr>
          </table>
          <!--table2-->
          <table class="table3">
            <tr>
              <td width="50px">
                <div class="con7">
                  <span class="checkbox">
                    <input type="checkbox" />
                  </span>支票付款
                </div>
              </td>
              <td width="175px">
                <span class="tdTit tdTit8">(付款行：</span>
                <div class="con8">
                  <input type="text" v-model="editedItem.bankName" style="width:130px;" />
                </div>
                <span class="tdTit tdTit9">銀行</span>
              </td>
              <td>
                <div class="con9">
                  <input type="text" v-model="editedItem.bankSubName" style="width:115px;" />
                </div>
                <span class="tdTit tdTit10">分行</span>
              </td>
            </tr>
          </table>
          <!--table3-->
          <table class="table4">
            <tr>
              <td width="195px">
                <span class="tdTit tdTit11">帳號：</span>
                <div class="con10">
                  <input type="text" v-model="editedItem.bankAccount" style="width:140px;" />
                </div>
              </td>
              <td width="210px">
                <span class="tdTit tdTit12">發票人：</span>
                <div class="con11">
                  <input type="text" v-model="editedItem.customer.name" style="width:104px;" />
                </div>
              </td>
              <td width="115px">
                <span class="tdTit tdTit13">發票日：</span>
                <div class="con12">
                  <input type="text" style="width:90px;" />
                </div>
              </td>
              <td>
                <span class="tdTit tdTit14">往來情形：</span>
                <div class="con13">
                  (<textarea></textarea>)
                </div>
              </td>
            </tr>
          </table>
          <div class="title3-1">手機</div>
          <table class="table5-1">
            <tr>
              <th width="192px"><span class="tdTit tdTit15-1">手機廠牌</span></th>
              <th width="182px"><span class="tdTit tdTit16-1">手機型號</span></th>
              <th class="thEnd"><span class="tdTit tdTit17-1">IMEI碼</span></th>
            </tr>
            <tr>
              <td><input type="text" v-model="editedItem.phoneVendor" class="text_c" style="width:150px;"></td>
              <td><input type="text" v-model="editedItem.phoneModel" class="text_c" style="width:150px;"></td>
              <td class="tdEnd"><input type="text"  v-model="editedItem.phoneIMEI" class="text_c" style="width:330px;"></td>
            </tr>
          </table>
          <!--table4-->
          <div class="title3-2">車輛</div>
          <table class="table5-2">
            <tr>
              <th width="192px">
                <span class="tdTit tdTit15">廠牌</span>
              </th>
              <th width="182px">
                <span class="tdTit tdTit16">車型</span>
              </th>
              <th width="192px">
                <span class="tdTit tdTit17">車號</span>
              </th>
              <th class="thEnd">
                <span class="tdTit tdTit18">出廠年/月</span>
              </th>
            </tr>
            <tr>
              <td>
                <input
                  type="text"
                  v-model="editedItem.laonhfcInfo.vendor"
                  class="text_c"
                  style="width:150px;"
                />
              </td>
              <td>
                <input
                  type="text"
                  v-model="editedItem.laonhfcInfo.name"
                  class="text_c"
                  style="width:150px;"
                />
              </td>
              <td>
                <input
                  type="text"
                  v-model="editedItem.laonhfcInfo.carId"
                  class="text_c"
                  style="width:150px;"
                />
              </td>
              <td class="tdEnd">
                <input type="text"
                v-model="editedItem.laonhfcInfo.manufactureDate"
                @click="showDateToolDialog('manufactureDate')"
                class="text_c" style="width:150px;" />
              </td>
            </tr>
          </table>
          <!--table5-->
        </div>
        <!--area1-->
        <div class="area2">
          <div class="title1">申請人</div>
          <table class="table6">
            <tr>
              <td width="174px">
                <span class="tdTit tdTit19">姓名：</span>
                <div class="con14">
                  <input type="text" v-model="editedItem.customer.name" style="width:120px;" />
                </div>
              </td>
              <td width="165px">
                <span class="tdTit tdTit20">身分證字號：</span>
                <div class="con15">
                  <input type="text" v-model="editedItem.customer.memberId" style="width:100px;" />
                </div>
              </td>
              <td width="102px">
                <div class="con16">
                  <span class="checkbox">
                    <input type="checkbox" v-model="editedItem.customer.married[0].value" />
                  </span>已婚
                  <span class="checkbox">
                    <input type="checkbox" v-model="editedItem.customer.married[1].value" />
                  </span>未婚
                </div>
              </td>
              <td class="tdEnd" width="105px">
                <span class="tdTit tdTit21">生日：</span>
                <div class="con17">
                  <input
                    type="text"
                    v-model="editedItem.customer.birthday"
                    @click="showDateToolDialog('birthday')"
                    style="width:70px;"
                    class="text_c"
                  />
                </div>
              </td>
              <td class="tdBorder">
                <span class="tdTit tdTit22">視訊照會時間：</span>
                <div class="con18">
                  <input type="text" style="width:120px;" />
                </div>
              </td>
            </tr>
          </table>
          <!--table6-->
          <table class="table7">
            <tr>
              <td width="317px">
                <span class="tdTit tdTit23">戶籍地址：</span>
                <div class="con19">
                  <span class="checkbox">
                    <input type="checkbox" v-model="editedItem.customer.home.homeType1[0].value"/>
                  </span>同身分證住址
                  <span class="checkbox">
                    <input type="checkbox" v-model="editedItem.customer.home.homeType1[1].value"/>
                  </span>其他
                  <input type="text" value="" placeholder="郵遞區號" v-model="editedItem.customer.home.residencePost" class="con57">
                  <input type="text" value="" placeholder="縣市" v-model="editedItem.customer.home.residenceCity" class="con58">
                  <input type="text" value="" placeholder="區鄉鎮" v-model="editedItem.customer.home.residenceArea" class="con59">
                  <input type="text" value="" placeholder="地址" v-model="editedItem.customer.home.residenceAddress" class="con60">
<!--                  <textarea v-model="editedItem.customer.home.residenceAddress"></textarea>-->
                </div>
              </td>
              <td width="106px">
                <span class="tdTit tdTit24">電話：</span>
                <div class="con20">
                  <input type="text" v-model="editedItem.customer.phone" style="width:90px;" />
                </div>
              </td>
              <td width="124px">
                <span class="tdTit tdTit25">行動電話：</span>
                <div class="con21">
                  <input type="text" v-model="editedItem.customer.cellphone" style="width:90px;" />
                </div>
              </td>
              <td class="tdEnd">
                <span class="tdTit tdTit26">LINE&nbsp;&nbsp;&nbsp;ID：</span>
                <div class="con22">
                  <input type="text" style="width:135px;" />
                </div>
              </td>
            </tr>
          </table>
          <!--table7-->
          <table class="table8">
            <tr>
              <td width="420px" class="tdEnd">
                <span class="tdTit tdTit27">通訊地址：</span>
                <div class="con23">
                  <span class="checkbox">
                    <input type="checkbox" v-model="editedItem.customer.home.homeType2[0].value" />
                  </span>戶籍
                  <span class="checkbox">
                    <input type="checkbox" v-model="editedItem.customer.home.homeType2[1].value" />
                  </span>公司地
                  <span class="checkbox">
                    <input type="checkbox" v-model="editedItem.customer.home.homeType2[2].value" />
                  </span>其他
<!--                  <textarea v-model="editedItem.customer.home.homeAddress1"></textarea>-->
                  <input type="text" value="" placeholder="郵遞區號" v-model="editedItem.customer.home.homePost" class="con61">
                  <input type="text" value="" placeholder="縣市" v-model="editedItem.customer.home.homeCity" class="con62">
                  <input type="text" value="" placeholder="區鄉鎮" v-model="editedItem.customer.home.homeArea" class="con63">
                  <input type="text" value="" placeholder="地址" v-model="editedItem.customer.home.homeAddress1" class="con64">
                </div>
              </td>
              <td width="174px">
                <span class="tdTit tdTit28">電話：</span>
                <div class="con24">
                  <input
                    type="text"
                    v-model="editedItem.customer.homePhone"
                    style="width:120px;"
                  />
                </div>
              </td>
              <td class="tdEnd">
                <div class="con25">
                  <span class="checkbox">
                    <input type="checkbox" />
                  </span>領有身心殘障手冊(&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;)
                  <textarea></textarea>
                </div>
              </td>
            </tr>
          </table>
          <!--table8-->
          <table class="table9">
            <tr>
              <td width="375px">
                <span class="tdTit tdTit29">現居地住</span>
                <div class="con26">
                  <input
                    type="text"
                    v-model="editedItem.customer.home.liveYear"
                    style="width:30px; text-align:center"
                  />
                </div>
                <span class="tdTit tdTit30">年</span>
                <div class="con27">
                  <span class="checkbox">
                    <input type="checkbox" v-model="editedItem.customer.home.liveLevel[0].value" />
                  </span>自有/配偶所有
                  <span class="checkbox">
                    <input type="checkbox" v-model="editedItem.customer.home.liveLevel[2].value" />
                  </span>父母/子女所有
                  <span class="checkbox">
                    <input type="checkbox" v-model="editedItem.customer.home.liveLevel[3].value" />
                  </span>租賃
                  <span class="checkbox" style="margin-left:3px; margin-right:-3px;">
                    <input type="checkbox" v-model="editedItem.customer.home.liveLevel[5].value" />
                  </span>其他
                  <textarea></textarea>
                </div>
              </td>
              <td width="121px">
                <span class="tdTit tdTit31">任職公司：</span>
                <div class="con28">
                  <textarea v-model="editedItem.company.name"></textarea>
                </div>
              </td>
              <td width="98px">
                <span class="tdTit tdTit32">職稱：</span>
                <div class="con29">
                  <textarea v-model="editedItem.company.title"></textarea>
                </div>
              </td>
              <td class="tdEnd">
                <span class="tdTit tdTit33">公司電話：</span>
                <div class="con30">
                  <input type="text" v-model="editedItem.company.phone" style="width:100px;" />
                </div>
              </td>
            </tr>
          </table>
          <!--table9-->
          <table class="table10">
            <tr>
              <td width="133px">
                <span class="tdTit tdTit34">年收入&nbsp;&nbsp;NT$</span>
                <div class="con31">
                  <input
                    type="text"
                    v-model="editedItem.company.yearSalary"
                    style="width:35px; text-align:center"
                  />
                </div>
                <span class="tdTit tdTit35">萬</span>
              </td>
              <td width="59px">
                <span class="tdTit tdTit36">年資</span>
                <div class="con32">
                  <input
                    type="text"
                    v-model="editedItem.company.workYear"
                    style="width:22px; text-align:center"
                  />
                </div>
                <span class="tdTit tdTit37">年</span>
              </td>
              <td width="108px">
                <span class="tdTit tdTit38">學歷：</span>
                <div class="con33">
                  <input type="text" style="width:90px;" v-model="editedItem.customer.education" />
                </div>
              </td>
              <td class="tdEnd">
                <span class="tdTit tdTit39">公司地址：</span>
                <div class="con34">
                  <input type="text" v-model="editedItem.company.address" style="width:470px;" />
                </div>
              </td>
            </tr>
          </table>
          <!--table10-->
        </div>
        <!--area2-->
        <div class="area3">
          <div class="title1">連帶保證人</div>
          <table class="table11">
            <tr>
              <td width="140px">
                <span class="tdTit tdTit40">姓名：</span>
                <div class="con35">
                  <input type="text" v-model="editedItem.jointGuarantor.name" style="width:100px;" />
                </div>
              </td>
              <td width="154px">
                <span class="tdTit tdTit41">身分證字號：</span>
                <div class="con36">
                  <input
                    type="text"
                    v-model="editedItem.jointGuarantor.memberId"
                    style="width:90px;"
                  />
                </div>
              </td>
              <td width="92px">
                <div class="con37">
                  <span class="checkbox">
                    <input type="checkbox" />
                  </span>已婚
                  <span class="checkbox">
                    <input type="checkbox" />
                  </span>未婚
                </div>
              </td>
              <td width="90px">
                <span class="tdTit tdTit42">生日：</span>
                <div class="con38">
                  <input type="text"
                  v-model="editedItem.jointGuarantor.birthday"
                    @click="showDateToolDialog('jointGuarantor.birthday')"
                     style="width:70px;" class="text_c" />
                </div>
              </td>
              <td width="69px" class="tdEnd">
                <span class="tdTit tdTit43">關係：</span>
                <div class="con39">
                  <input
                    type="text"
                    v-model="editedItem.jointGuarantor.type"
                    style="width:45px;"
                    class="text_c"
                  />
                </div>
              </td>
              <td class="tdBorder">
                <span class="tdTit tdTit44">視訊照會時間：</span>
                <div class="con40">
                  <input type="text" style="width:120px;" />
                </div>
              </td>
            </tr>
          </table>
          <!--table11-->
          <table class="table12">
            <tr>
              <td width="317px">
                <span class="tdTit tdTit45">戶籍地址：</span>
                <div class="con41">
                  <span class="checkbox">
                    <input type="checkbox" v-model="editedItem.jointGuarantor.home.homeType1[0].value"/>
                  </span>同身分證住址
                  <span class="checkbox">
                    <input type="checkbox" v-model="editedItem.jointGuarantor.home.homeType1[1].value"/>
                  </span>其他
                  <textarea v-model="editedItem.jointGuarantor.home.residenceAddress"></textarea>
                </div>
              </td>
              <td width="106px">
                <span class="tdTit tdTit46">電話：</span>
                <div class="con42">
                  <input type="text" v-model="editedItem.jointGuarantor.phone" style="width:90px;" />
                </div>
              </td>
              <td width="124px">
                <span class="tdTit tdTit47">行動電話：</span>
                <div class="con43">
                  <input
                    type="text"
                    v-model="editedItem.jointGuarantor.cellphone"
                    style="width:90px;"
                  />
                </div>
              </td>
              <td class="tdEnd">
                <span class="tdTit tdTit48">LINE&nbsp;&nbsp;&nbsp;ID：</span>
                <div class="con44">
                  <input type="text" style="width:135px;" />
                </div>
              </td>
            </tr>
          </table>
          <!--table12-->
          <table class="table13">
            <tr>
              <td width="450px" class="tdEnd">
                <span class="tdTit tdTit49">通訊地址：</span>
                <div class="con45">
                  <span class="checkbox">
                    <input type="checkbox" v-model="editedItem.jointGuarantor.home.homeType2[0].value"/>
                  </span>戶籍
                  <span class="checkbox">
                    <input type="checkbox" v-model="editedItem.jointGuarantor.home.homeType2[1].value"/>
                  </span>公司地
                  <span class="checkbox">
                    <input type="checkbox" v-model="editedItem.jointGuarantor.home.homeType2[2].value"/>
                  </span>其他
                  <textarea v-model="editedItem.jointGuarantor.home.homeAddress1"></textarea>
                </div>
              </td>
              <td width="134px">
                <span class="tdTit tdTit50">電話：</span>
                <div class="con46">
                  <input
                    type="text"
                    v-model="editedItem.jointGuarantor.homePhone"
                    style="width:120px;"
                  />
                </div>
              </td>
              <td class="tdEnd">
                <div class="con47">
                  <span class="checkbox">
                    <input type="checkbox" />
                  </span>領有身心殘障手冊(&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;)
                  <textarea></textarea>
                </div>
              </td>
            </tr>
          </table>
          <!--table13-->
          <table class="table14">
            <tr>
              <td width="339px">
                <span class="tdTit tdTit51">現居地住</span>
                <div class="con48">
                  <input
                    type="text"
                    v-model="editedItem.jointGuarantor.home.liveYear2"
                    style="width:30px; text-align:center"
                  />
                </div>
                <span class="tdTit tdTit52">年</span>
                <div class="con49">
                  <span class="checkbox">
                    <input
                      type="checkbox"
                      v-model="editedItem.jointGuarantor.home.liveLevel2[0].value"
                    />
                  </span>自有/配偶所有
                  <span class="checkbox">
                    <input
                      type="checkbox"
                      v-model="editedItem.jointGuarantor.home.liveLevel2[2].value"
                    />
                  </span>父母/子女所有
                  <span class="checkbox">
                    <input
                      type="checkbox"
                      v-model="editedItem.jointGuarantor.home.liveLevel2[3].value"
                    />
                  </span>租賃
                  <span class="checkbox" style="margin-left:3px; margin-right:-3px;">
                    <input
                      type="checkbox"
                      v-model="editedItem.jointGuarantor.home.liveLevel2[5].value"
                    />
                  </span>其他
                  <textarea></textarea>
                </div>
              </td>
              <td width="245px">
                <span class="tdTit tdTit53">學歷</span>
                <div class="con50">
                  <span class="checkbox">
                    <input type="checkbox" v-model="editedItem.customer.educationLevel[1].value"/>
                  </span>研究所
                  <span class="checkbox">
                    <input type="checkbox" v-model="editedItem.customer.educationLevel[2].value"/>
                  </span>大學&nbsp;/&nbsp;大專
                  <span class="checkbox">
                    <input type="checkbox" v-model="editedItem.customer.educationLevel[4].value"/>
                  </span>高中職
                  <span class="checkbox">
                    <input type="checkbox" v-model="editedItem.customer.educationLevel[5].value"/>
                  </span>初中及以下
                </div>
              </td>
              <td width="99px">
                <span class="tdTit tdTit54">年收入&nbsp;NT$</span>
                <div class="con51">
                  <input type="text" v-model="editedItem.jointGuarantor.yearSalary" style="width:35px; text-align:center" />
                </div>
                <span class="tdTit tdTit55">萬</span>
              </td>
              <td class="tdEnd">
                <span class="tdTit tdTit56">年資</span>
                <div class="con52">
                  <input type="text" v-model="editedItem.jointGuarantor.workYear" style="width:22px; text-align:center" />
                </div>
                <span class="tdTit tdTit57">年</span>
              </td>
            </tr>
          </table>
          <!--table14-->
          <table class="table15">
            <tr>
              <td width="152px">
                <span class="tdTit tdTit58">任職公司：</span>
                <div class="con53">
                  <textarea v-model="editedItem.jointGuarantor.companyName"></textarea>
                </div>
              </td>
              <td width="108px">
                <span class="tdTit tdTit59">職稱：</span>
                <div class="con54">
                  <textarea v-model="editedItem.jointGuarantor.title"></textarea>
                </div>
              </td>
              <td width="345px" class="tdEnd">
                <span class="tdTit tdTit60">公司地址：</span>
                <div class="con55">
                  <textarea v-model="editedItem.jointGuarantor.companyAddress"></textarea>
                </div>
              </td>
              <td class="tdEnd">
                <span class="tdTit tdTit61">電話：</span>
                <div class="con56">
                  <input
                    type="text"
                    v-model="editedItem.jointGuarantor.companyPhone"
                    style="width:110px;"
                  />
                </div>
              </td>
            </tr>
          </table>
          <!--table15-->
        </div>
        <!--area3-->
        <div class="area4">
          <div class="title1">聲明事項暨同意事項</div>
          <div class="ulBox">
            <ul class="list">
              <li>
                <b>
                  <u>辦理本專案所檢附之申請文件及申請表格(含本申請書)與同意先行簽署用印本契約及相關之債權文件，如因故無法通過貴公司之審核或已核准後，申請人未與貴公司往來者，申請人及連帶保證人等同意貴公司無須返還相關文件。</u>
                </b>
              </li>
              <li>申請人等知悉本專案可由貴公司委託之公司或人員處理有關本專案之申請作業，惟未透過其他代辦公司辦理。除買賣合約所載費用外，無其他人員向申請人等收取額外費用或報酬。</li>
              <li>
                <b>
                  <u>申請人等知悉貴公司保留核准本專案與否及最終交易金額、期間等各項條件之權利。申請人知悉並同意支付經銷商手續費作為本專案核准後車輛動產抵押規費及設定服務費用。</u>
                </b>
              </li>
              <li>申請人等同意因保全本債權所生之費用(含占有抵押標的物)、訴訟費用及所受之損失，概由申請人等負擔。</li>
              <li>
                <b>個人資料保護法告知事項:</b>
              </li>
            </ul>
          </div>
          <!--ulBox-->
          <p class="p1">
            合迪股份有限公司(以下稱本公司)依據個人資料保護法(以下稱個資法)規定，向申請人告知下列事項，請 申請人詳閱:(1)蒐集之目的:(一)辦理本公司經 營合於營業登記項目或組織章程所定之業務(包括但不限於租賃、分期付款買賣、資金貸與、應收帳款受讓暨管理等相關業務);(二)契約、類似契約或其他法 律關係事務;核貸與授信業務;帳務管理及債權交易業務;授信業務;債權整貼現及收買業務;徵信業務(包括但不限於產業上下游及同業間彼此照會、租賃同 業、關係企業、票信等照會之徵信行為);(三)調查、統計與研究分析(包括但不限於財團法人資訊工業策進會等研究分析機構);(四)消費者管理、客戶管理與 服務、消費者保護;(五)資(通)訊服務、資(通)訊與資料庫管理、資通安全與管理;及(六)行銷(包括但不限於本公司及其母公司中租控股股份有限公司暨其 子(孫)公司及其業務委外機構等，於行銷或合作目的之範圍內使用等)。蒐集之個人資料類別:依個人資料保護法第二條第一項所定義之個人資料，包含識別類 (包括但不限於姓名、國民身分證統一編號及聯絡方式)、特徵類、家庭情形、社會情況、教育、考選、技術或其他專業、受僱情形、財務細節(包括但不限於個人 所得資料、財產資料、綜合所得稅及房地合一稅繳納、欠稅及退稅紀錄等財務相關之資料)、保險資料(包括但不限於個人投保及退保資料、勞工保險被保險人投 保資料等保險有關之資料)、商業資訊(包括與本公司相關業務之申請書或契約書內容及其他具有正當合理關聯之紀錄)，但仍以本公司與申請人往來之相關業務 所實際蒐集之個人資料為準。(2)個人資料利用之期間、對象、地區及方式:
            <b>
              <u>期間</u>
            </b>：個人資料蒐集之特定目的存續期間、依相關法令或契約約定之保存期限(如: 商業會計法等)或本公司因執行業務所必須之保存期間。
            <b>
              <u>對象</u>
            </b>：本公司、本公司之關係企業及其母公司中租控股股份有限公司暨其子公司、財團法人金融聯合 徵信中心、票據交換所、財金資訊公司、代理收付款項業務機構、業務委外機構、未受中央目的事業主管機關限制之個人資料之接收者、本公司之共同行銷或交 互運用客戶之機構、本公司合作推廣對象、與本公司有業務往來之機構、依法有調查權機關或金融監理機關或其他法令得蒐集、處理及利用資料之人。
            <b>
              <u>申請人 並同意本公司得基於徵信之需要而代理申請人並使用申請人之個人資料暨銀行資料向發卡銀行及電信公司等為相關查詢。若申請人自行向財團法人金融聯合徵 信中心申請查詢並調閱取得信用報告後，或由您自行於個人化資料自主運用平台調閱並取得相關資料，申請人再自行將信用報告及其他調閱並取得之資料交付 本公司時，申請人同意本公司得以在與申請人業務往來或申請人所保證之主債務人往來評估範圍內利用申請人所交付前揭報告資料</u>
            </b>。地區:前揭利用對象之營 業處所所在地及未受中央目的事業主管機關限制之個人資料之接收者所在地。方式:以自動化機器或其他非自動化方式之利用方式(例如使用電子文件、紙本或 其他合於當時科技之適當方式)或符合個人資料保護法第20條規定之利用。申請人得透過書面或本公司同意之其他方式，依據個資法第三條規定，就本公司保有 申請人之個人資料申請行使下列權利:得向本公司查詢、請求閱覽或請求製給複製本，而本公司依法得酌收必要成本費用。得向本公司請求補充或更正，惟依 法申請人應為適當之釋明。得向本公司請求停止蒐集、處理或利用及請求刪除，惟依法本公司因執行業務所必須者，得不依申請人請求為之。申請人得自由選 擇是否提供相關個人資料，惟申請人若拒絕提供相關個人資料，本公司將無法進行必要之審核及處理作業，致無法提供申請人完善之相關業務或服務。
            <br/>
            <b>
              6.企業社會責任/個人社會責任同意事項
            </b>
            <br/>
            台端茲同意響應聯合國永續發展目標，在追求成長過程中同時兼顧永續發展、公司治理並落實企業社會責任/個人社會責任，並隨時檢討實施成效及持續改進。 倘行為違反前開約定，致使對於環境保護或社會公益造成危害，台端同意配合主管機關之要求於期限內進行改善，且願將改善情形提供予貴公司追蹤審查。
          </p>
          <p
            class="p2"
          >=======================================================================================</p>
          <p class="p3">
            <b>
              上述聲明及告知事項申請人已清楚明瞭其內容無誤知悉貴公司蒐集、處理或利用申請人個人資料之目的及用途，申請人並同意貴公司在上開告知事項範圍內，
              <u>得蒐集、處理或利用申請人之個人資料，且申請人提供與貴公司之資料若包含申請人以外第三人之個人資料時，申請人已以適當方式使該第三人知悉其個人資 料會提供與貴公司於本同意書範圍內，進行蒐集、處理或利用，另亦同意企業社會責任/個人社會責任同意事項</u>。
            </b>
          </p>
          <p class="p4">
            此致
            <br />
            <span>合迪股份有限公司</span>
          </p>
          <span class="sign1">申請人簽章</span>
          <img
            class="signbox"
            :src="signImageSrc('customer')"
            @click="showSignDialog('customer')"
          />
          <span class="sign2">連帶保證人簽章</span>
          <img
            class="signbox"
            :src="signImageSrc('jointGuarantor')"
            @click="showSignDialog('jointGuarantor')"
          />
          <div class="line"></div>
        </div>
        <!--area4-->
        <span class="ps">機車及手機專用&nbsp;小車&nbsp;AR(原)2023.07</span>
      </div>
      <!--page1-->
    </div>
    <!--wrapper-->
    <div class="btn">
      <span class="mr-2 subheading red--text" v-if="loading">案件上傳中 請勿關閉視窗</span>
      <v-btn class="primary" dark text :loading="loading" @click="save">確認上傳</v-btn>
      <!-- <a href @click.prevent="save">確認上傳</a> -->
    </div>

    <v-card >
      <v-card-title>
        <span class="title">PDF檔 / Zip檔</span>
      </v-card-title>
      <v-layout m-2 v-if="(editedItem.imageList && editedItem.imageList.length)"
                v-for="(url, i) in editedItem.imageList" :key="i">
        <v-flex>
          <a class="subheading m-2" :href="url" target="_blank">
            檔案 #{{ i+1}}
          </a></v-flex>
      </v-layout>
      <v-layout ml-2 v-if="(editedItem.fileList && editedItem.fileList.length)"
                v-for="(file, i) in editedItem.fileList" :key="i">
        <v-flex ml-2>
          <a class="subheading" :href="file.data" target="_blank">
            {{file.imageName}}
          </a></v-flex>
      </v-layout>
    </v-card>

     <v-dialog
      v-model="dateInfoDialog.visible"
      :width="isMobile ? '90%' : '60%'">
      <v-card>
        <v-card-title class="headline">
          {{dateInfoDialog.text}}
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-layout row wrap v-if="dateInfoDialog.key === 'birthday'">
            <v-flex sm3>
                <v-text-field outlined v-model="editedItem.customer.birthdayInfo.year" length="3" maxlength="3"
                          placeholder="年(民國)"></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-text-field outlined v-model="editedItem.customer.birthdayInfo.month" length="2" maxlength="2"
                          placeholder="月(ex. 01)"></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-text-field outlined v-model="editedItem.customer.birthdayInfo.day" length="2" maxlength="2"
                          placeholder="日(ex. 01)"></v-text-field>
            </v-flex>
          </v-layout>

          <div v-if="dateInfoDialog.key === 'memberIdDate'">
            <v-layout row wrap>
              <v-flex sm3>
                <v-text-field outlined v-model="editedItem.customer.memberIdDateInfo.year" length="3" maxlength="3"
                          placeholder="年(民國)"></v-text-field>
              </v-flex>
              <v-flex sm3>
                <v-text-field outlined v-model="editedItem.customer.memberIdDateInfo.month" length="2" maxlength="2"
                          placeholder="月(ex. 01)"></v-text-field>
              </v-flex>
              <v-flex sm3>
                <v-text-field outlined v-model="editedItem.customer.memberIdDateInfo.day" length="2" maxlength="2"
                          placeholder="日(ex. 01)"></v-text-field>
              </v-flex>
            </v-layout>
          </div>
          <div v-if="dateInfoDialog.key === 'jointGuarantor.birthday'">
            <v-layout row wrap>
              <v-flex sm3>
                <v-text-field outlined v-model="editedItem.jointGuarantor.birthdayInfo.year" length="3" maxlength="3"
                          placeholder="年(民國)"></v-text-field>
              </v-flex>
              <v-flex sm3>
                <v-text-field outlined v-model="editedItem.jointGuarantor.birthdayInfo.month" length="2" maxlength="2"
                          placeholder="月(ex. 01)"></v-text-field>
              </v-flex>
              <v-flex sm3>
                <v-text-field outlined v-model="editedItem.jointGuarantor.birthdayInfo.day" length="2" maxlength="2"
                          placeholder="日(ex. 01)"></v-text-field>
              </v-flex>
            </v-layout>
          </div>
          <div v-if="dateInfoDialog.key === 'jointGuarantor.memberIdDate'">
            <v-layout row wrap>
              <v-flex sm3>
                <v-text-field outlined v-model="editedItem.jointGuarantor.memberIdDateInfo.year" length="3" maxlength="3"
                          placeholder="年(民國)"></v-text-field>
              </v-flex>
              <v-flex sm3>
                <v-text-field outlined v-model="editedItem.jointGuarantor.memberIdDateInfo.month" length="2" maxlength="2"
                          placeholder="月(ex. 01)"></v-text-field>
              </v-flex>
              <v-flex sm3>
                <v-text-field outlined v-model="editedItem.jointGuarantor.memberIdDateInfo.day" length="2" maxlength="2"
                          placeholder="日(ex. 01)"></v-text-field>
              </v-flex>
            </v-layout>
          </div>
          <div v-if="dateInfoDialog.key === 'manufactureDate'">
            <v-layout row wrap>
              <v-flex sm4>
                <v-text-field outlined v-model="editedItem.laonhfcInfo.publicYear" length="4" maxlength="4"
                          placeholder="西年"></v-text-field>
              </v-flex>
              <v-flex sm1>

              </v-flex>
              <v-flex sm4>
                <v-text-field outlined v-model="editedItem.laonhfcInfo.publicMonth" length="2" maxlength="2"
                          placeholder="月(ex. 01)"></v-text-field>
              </v-flex>
            </v-layout>
          </div>

        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="primary" dark text @click="dateInfoDialog.confirm">確定</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!--提示-->
    <alert-view :visible="messageDialog.visible"
                :title="messageDialog.title"
                :content="messageDialog.text"
                :show-cancel="messageDialog.showCancel"
                @confirmEvent="messageDialog.confirm"
                @cancelEvent="messageDialog.cancel"></alert-view>

    <v-dialog
      fullscreen hide-overlay
      v-model="signDialog.visible">
      <v-card>
        <v-card-text>
          <draw-canvas :visible="signDialog.visible" :background-color="'#e6e6e6'" @handleDownloadSign="handleDownloadSign" @closeEvent="handleDownloadClose"></draw-canvas>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import ApplicationModel from '../../models/ApplicationModel';
import DrawCanvas from "@/components/DrawCanvas";
import AlertView from "@/components/AlertView";
import common from '@/mixins/common';
export default {
  name: "FinatradeEditView",
  props: {
    item: Object,
    loading: Boolean,
    isSaveSuccess: Boolean
  },
  components: { DrawCanvas, AlertView },
  data() {
    return {
      priceData: require('../../assets/credit_bonus_price'),
      creditPriceData: require("../../assets/credit_price"),
      dateInfoDialog: {
        key: "",
        title: "",
        text: "",
        visible: false,
        confirm: () => {},
        cancel: () => {},
      },
      editedItem: new ApplicationModel(),
      messageDialog: {
        title: '',
        text: '',
        visible: false,
        showCancel: false,
        confirm: () => {
        },
        cancel: () => {
        },
      },
      signDialog: {
        title: "",
        text: "",
        visible: false,
        confirm: () => {},
        cancel: () => {}
      },
      itemDetail: null,
    };
  },
  mixins:[common],
  computed: {
    ...mapGetters([
      "getUserInfo",
      "getAgentList",
      "getCreditItem",
      "getAgentInfo",
    ]),
    canCustomPrice() {
      // if (
      //   this.getAgentInfo.agentId === "KwarcyDi4BOv75RNE5SLBOwvia32" ||
      //   this.getAgentInfo.agentId === "t76gyOZwV8NouQAD6WoTEH7cSzB2" ||
      //   this.getAgentInfo.agentId === "MXiKEOWVx8O0OxlBjab5Yro9dOr1" ||
      //   this.getAgentInfo.canCustomPrice === true ||
      //   this.isAdmin
      // ) {
      //   return true;
      // }
      return false;
    },
    isAdmin() {
      return this.getUserInfo.authority === "admin";
    },
    publicYearList() {
      const start = new Date().getFullYear();
      const end = 1911;
      const list = [];
      for (let i = start; i >= end; i--) {
        list.push({ key: `${i}`, name: `${i}年` });
      }
      return list;
    },
    publicMonthList() {
      return [
        { name: "01月", key: "01" },
        { name: "02月", key: "02" },
        { name: "03月", key: "03" },
        { name: "04月", key: "04" },
        { name: "05月", key: "05" },
        { name: "06月", key: "06" },
        { name: "07月", key: "07" },
        { name: "08月", key: "08" },
        { name: "09月", key: "09" },
        { name: "10月", key: "10" },
        { name: "11月", key: "11" },
        { name: "12月", key: "12" },
      ];
    },
    yearList() {
      const start = new Date().getFullYear();
      const end = 1911;
      const list = [];
      for (let i = start; i >= end; i--) {
        list.push({ key: `${i - 1911}`, name: `${i - 1911}` });
      }
      return list;
    },
    monthList() {
      return [
        { name: "01", key: "01" },
        { name: "02", key: "02" },
        { name: "03", key: "03" },
        { name: "04", key: "04" },
        { name: "05", key: "05" },
        { name: "06", key: "06" },
        { name: "07", key: "07" },
        { name: "08", key: "08" },
        { name: "09", key: "09" },
        { name: "10", key: "10" },
        { name: "11", key: "11" },
        { name: "12", key: "12" },
      ];
    },
    dayList() {
      const startIndex = 1;
      const list = [];
      for (let i = startIndex; i <= 31; i++) {
        if (i < 10) {
          list.push({ key: `0${i}`, name: `0${i}` });
        } else {
          list.push({ key: `${i}`, name: `${i}` });
        }
      }
      return list;
    },
    getInstallmentsNumberList() {
      return [18, 20, 24, 30, 36, 48];
    },
    getCreditPriceList() {
      const list = [];
      let end = 350000;
      for (let i = 30000; i <= end; i += 10000) {
        list.push(i);
      }
      return list;
    },
    // getManufactureDate() {
    //   if (!this.editedItem.laonhfcInfo.publicYear && !this.editedItem.laonhfcInfo.publicMonth) {
    //     return ''
    //   }
    //   const publicYear = this.editedItem.laonhfcInfo.publicYear;
    //   return `${publicYear}/${this.editedItem.laonhfcInfo.publicMonth}`
    // },
    // getYearSalary() {
    //   return parseInt(this.editedItem.company.yearSalary) / 10000
    // }
  },
  created() {
    this.checkItemExist();
  },
  methods: {
    ...mapActions([
      "saveFinanceCreditData",
      "fetchCreditProductInfo",
      "saveFinanceInfo",
    ]),
    checkItemExist() {
      this.editedIndex = this.$route.query.editIndex;

      if (this.editedIndex === 0 || parseInt(this.editedIndex, 10) === 0) {
        // 編輯
        this.fetchCreditProductInfo({ caseId: this.$route.query.caseId }).then(
          results => {
            if (results.length === 0) {
              // 重複
              this.showMessageDialog(
                "錯誤",
                "查無資料",
                true,
                () => {},
                () => {}
              );
            } else {
              this.editedItem = results[0];
              this.editedItem.category = parseInt(this.$route.query.caseCategory, 10);
              this.editedItem.platform = parseInt(this.$route.query.platform,10);
              if(this.editedItem.platform !== 2) {
                this.editedItem.platform = 2;
                this.editedItem.caseId = Math.uuidFast();
                console.log(`platform == ${this.editedItem.platform}`)
              }
              if (!this.editedItem.vendor.signature) {
                this.editedItem.vendor.signature = "";
              }
              if (!this.editedItem.customer.birthdayInfo) {
                this.$set(this.editedItem.customer, "birthdayInfo", {
                  year: "",
                  month: "",
                  day: "",
                  isRepublic: true,
                  startCount: 0
                });
              }
              if (!this.editedItem.signImage0) {
                this.editedItem.signImage0 = null;
              }
              if (!this.editedItem.signImage1) {
                this.editedItem.signImage1 = null;
              }
              if (!this.editedItem.signImage2) {
                this.editedItem.signImage2 = null;
              }
              if (!this.editedItem.signImage0Url) {
                this.editedItem.signImage0Url = null;
              }
              if (!this.editedItem.signImage1Url) {
                this.editedItem.signImage1Url = null;
              }
              if (!this.editedItem.signImage2Url) {
                this.editedItem.signImage2Url = null;
              }
              if (!this.editedItem.phoneVendor) {
                this.editedItem.phoneVendor = '';
              }
              if (!this.editedItem.phoneModel) {
                this.editedItem.phoneModel = '';
              }
              if (!this.editedItem.phoneIMEI) {
                this.editedItem.phoneIMEI = '';
              }

              this.editedItem.customer.education = this.getEducation(this.editedItem.customer);
              //this.editedItem.company.yearSalary = parseInt(this.editedItem.company.salary * 12) / 10000
              // this.editedItem.customer.home.residenceAddress = `${this.editedItem.customer.home.residenceCity}${this.editedItem.customer.home.residenceArea}${this.editedItem.customer.home.residenceAddress}`
              // this.editedItem.customer.home.homeAddress1 = `${this.editedItem.customer.home.homeCity}${this.editedItem.customer.home.homeArea}${this.editedItem.customer.home.homeAddress1}`
              // this.editedItem.vendor.productName = this.getCaseProduct(this.editedItem.vendor);
              this.changeInstallmentsNumber()
              console.log(`editedItem ===  ${JSON.stringify( this.editedItem)}`)
            }
          }
        );
      } else {

        this.editedItem.caseId = Math.uuidFast();
        this.editedItem.displayId = this.$route.query.caseId;
        this.editedItem.category = parseInt(this.$route.query.caseCategory, 10);

        const now = new Date();
        this.editedItem.applyDate.year = `${now.getFullYear() - 1911}`;
        this.editedItem.applyDate.month = `${
          now.getMonth() + 1 < 10 ? `0${now.getMonth() + 1}` : now.getMonth() + 1
        }`;
        this.editedItem.applyDate.day = `${
          now.getDate() + 1 < 10 ? `0${now.getDate()}` : now.getDate()
        }`;

        this.editedItem.vendor.productName = "";
      }

      if (this.getAgentInfo) {
        if (this.getAgentInfo.enableFinanceAgent) {
          this.editedItem.vendor.salesCellphone = this.getAgentInfo.financePhone;
          this.editedItem.vendor.signature = this.getAgentInfo.financeName;
        }
      }
    },
    changeInstallmentsNumber() {
      console.log(`changeInstallmentsNumber = ${JSON.stringify(this.priceData)} | ${this.editedItem.vendor.installmentsNumber}`);
      const find = this.priceData["0"][this.editedItem.vendor.installmentsNumber][0];

      // const key = `${this.editedItem.vendor.totalPrice}-${this.editedItem.vendor.installmentsNumber}`;
      // const find = this.creditPriceData[key];
      if (find) {
        // console.log(`${parseInt(this.editedItem.creditPriceMonth)} / ${parseInt(find.price)}`);
        const price = find.monthPrice * (this.editedItem.vendor.totalPrice / 10000)

        this.editedItem.vendor.creditPriceMonth = parseInt(price);
        this.calculationTotal();
        // console.log(`${JSON.stringify(this.editedItem)}`);
      }
    },
    calculationTotal(){
      this.editedItem.vendor.totalCreditPrice = parseInt(this.editedItem.vendor.installmentsNumber) * parseInt(this.editedItem.vendor.creditPriceMonth);
    },
    showDateToolDialog(key) {
      console.log(`showDateToolDialog`)
      this.dateInfoDialog.key = key;
      this.dateInfoDialog.visible = true;
      this.dateInfoDialog.text = "請選擇日期";
      this.dateInfoDialog.confirm = () => {
        // console.log(JSON.stringify(this.editedItem.customer.birthdayInfo));
        if (key === "birthday") {
          this.editedItem.customer.birthday = `${this.editedItem.customer.birthdayInfo.year}年${this.editedItem.customer.birthdayInfo.month}月${this.editedItem.customer.birthdayInfo.day}日`;
        }
        if (key === "memberIdDate") {
          this.editedItem.customer.memberIdDate = `${this.editedItem.customer.memberIdDateInfo.year}年${this.editedItem.customer.memberIdDateInfo.month}月${this.editedItem.customer.memberIdDateInfo.day}日`;
        }
        if (key === "jointGuarantor.birthday") {
          this.editedItem.jointGuarantor.birthday = `${this.editedItem.jointGuarantor.birthdayInfo.year}年${this.editedItem.jointGuarantor.birthdayInfo.month}月${this.editedItem.jointGuarantor.birthdayInfo.day}日`;
        }
        if (key === "jointGuarantor.memberIdDate") {
          this.editedItem.jointGuarantor.memberIdDate = `${this.editedItem.jointGuarantor.memberIdDateInfo.year}年${this.editedItem.jointGuarantor.memberIdDateInfo.month}月${this.editedItem.jointGuarantor.memberIdDateInfo.day}日`;
        }
        if (key === "manufactureDate") {
          this.editedItem.laonhfcInfo.manufactureDate = `${this.editedItem.laonhfcInfo.publicYear}/${this.editedItem.laonhfcInfo.publicMonth}`;
        }
        this.dateInfoDialog.visible = false;
      };
    },
    save() {
      if (this.checkFormData()) {
        this.editedItem.customer.memberId = this.editedItem.customer.memberId.toUpperCase();
        this.editedItem.platform = 2; // 中租
        this.$emit('saveData', this.editedItem);
      }
    },
    showMessageDialog(title, text, visible, confirmEvent, cancelEvent) {
      this.messageDialog.title = title;
      this.messageDialog.text = text;
      this.messageDialog.visible = visible;
      const self = this;
      this.messageDialog.confirm = () => {
        self.messageDialog.visible = false;
        if (confirmEvent) {
          confirmEvent();
        }
      };

      this.messageDialog.cancel = () => {
        self.messageDialog.visible = false;
        if (cancelEvent) {
          cancelEvent();
        }
      };
    },
    signImageSrc(itemPath) {
      let source = null;
      if (itemPath === "customer") {
        if (this.editedItem.signImage0) {
          source = this.editedItem.signImage0;
        } else if (this.editedItem.signimage0Url) {
          source = this.editedItem.signimage0Url;
        }
      } else if (itemPath === "jointGuarantor") {
        if (this.editedItem.signImage3) {
          source = this.editedItem.signImage3;
        } else if (this.editedItem.signimage3Url) {
          source = this.editedItem.signimage3Url;
        }
      }
      return source;
    },
    showSignDialog(key) {
      this.signKey = key;
      this.signDialog.visible = true;
    },
    handleDownloadSign(image) {
      if (this.signKey === "customer") {
        this.editedItem.signImage0 = image;
      } else if (this.signKey === "jointGuarantor") {
        this.editedItem.signImage3 = image;
      }
      this.signDialog.visible = false;
      this.signDialog.confirm = () => {
        if (this.signKey === "customer") {
          this.editedItem.signImage0 = image;
        } else if (this.signKey === "jointGuarantor") {
          this.editedItem.signImage3 = image;
        }
        this.signDialog.visible = false;
      };
    },
    handleDownloadClose() {
      this.signDialog.visible = false
    },
    getCaseProduct(item) {
            if (item.productId === '0') {
              return '機車原融';
            }
            if (item.productId === '1') {
              return '借新還舊';
            }
            if (item.productId === '2') {
              return '他行代償';
      }
      return '機車原融';
    },
    checkFormData() {

      console.log(``)

      if (this.editedItem.vendor.installmentsNumber　=== '') {
        this.showMessageDialog('錯誤', '請填寫期數！', true, () => {
        }, () => {
        });
        return false;
      }
      if (this.editedItem.vendor.creditPriceMonth=== '') {
        this.showMessageDialog('錯誤', '請填寫期付款！', true, () => {
        }, () => {
        });
        return false;
      }
      if(!this.editedItem.paymentInfo.isBankBillPay && !this.editedItem.paymentInfo.isPostBillPay && !this.editedItem.paymentInfo.isAtmBillPay &&
        !this.editedItem.paymentInfo.isStoreBillPay && !this.editedItem.paymentInfo.isAutoBillPay) {
          this.showMessageDialog('錯誤', '付款方式至少要勾選一個！', true, () => {
          }, () => {
          });
        return false;
      }
      if(!this.editedItem.paymentInfo.debitNote.isRegistration && !this.editedItem.paymentInfo.debitNote.isMailingAddress &&
        !this.editedItem.paymentInfo.debitNote.isCompanyAddress && !this.editedItem.paymentInfo.debitNote.isOtherAddress){
          this.showMessageDialog('錯誤', '寄送地址至少要勾選一個！', true, () => {
          }, () => {
          });
        return false;
      }
      if (this.editedItem.laonhfcInfo.vendor === '') {
        this.showMessageDialog('錯誤', '請填寫廠牌！', true, () => {
        }, () => {
        });
        return false;
      }
      if (this.editedItem.laonhfcInfo.name === '') {
        this.showMessageDialog('錯誤', '請填寫車型！', true, () => {
        }, () => {
        });
        return false;
      }
      if (this.editedItem.laonhfcInfo.carId === '') {
        this.showMessageDialog('錯誤', '請填寫車號！', true, () => {
        }, () => {
        });
        return false;
      }
      if (this.editedItem.laonhfcInfo.manufactureDate === '') {
        this.showMessageDialog('錯誤', '請填寫出廠年月！', true, () => {
        }, () => {
        });
        return false;
      }
      if (this.editedItem.customer.name === '') {
        this.showMessageDialog('錯誤', '請填寫姓名！', true, () => {
        }, () => {
        });
        return false;
      }
      if (this.editedItem.customer.memberId === '') {
        this.showMessageDialog('錯誤', '請填寫身分證！', true, () => {
        }, () => {
        });
        return false;
      }
      if (this.editedItem.customer.birthday === '') {
        this.showMessageDialog('錯誤', '請填寫生日！', true, () => {
        }, () => {
        });
        return false;
      }
      if (!this.editedItem.customer.home.homeType1[0].value && !this.editedItem.customer.home.homeType1[1].value){
        this.showMessageDialog('錯誤', '申請人戶籍地址請勾選一個！', true, () => {
        }, () => {
        });
        return false;
      }
      if (!this.editedItem.customer.home.homeType2[0].value && !this.editedItem.customer.home.homeType2[1].value && !this.editedItem.customer.home.homeType2[2].value){
        this.showMessageDialog('錯誤', '申請人通訊地址請勾選一個！', true, () => {
        }, () => {
        });
        return false;
      }
      if (this.editedItem.customer.phone === '') {
        this.showMessageDialog('錯誤', '請填寫戶籍電話！', true, () => {
        }, () => {
        });
        return false;
      }
      if (this.editedItem.customer.cellphone === '') {
        this.showMessageDialog('錯誤', '請填寫手機號碼！', true, () => {
        }, () => {
        });
        return false;
      }
      if (this.editedItem.customer.homePhone === '') {
        this.showMessageDialog('錯誤', '請填寫居住電話！', true, () => {
        }, () => {
        });
        return false;
      }
      if (this.editedItem.company.name === '') {
        this.showMessageDialog('錯誤', '請填寫任職公司！', true, () => {
        }, () => {
        });
        return false;
      }
      if (this.editedItem.company.title === '') {
        this.showMessageDialog('錯誤', '請填寫職稱！', true, () => {
        }, () => {
        });
        return false;
      }
      if (this.editedItem.company.phone === '') {
        this.showMessageDialog('錯誤', '請填寫公司電話！', true, () => {
        }, () => {
        });
        return false;
      }
      if (this.editedItem.company.yearSalary === '') {
        this.showMessageDialog('錯誤', '請填寫申請人年收入！', true, () => {
        }, () => {
        });
        return false;
      }
      if (this.editedItem.company.workYear === '') {
        this.showMessageDialog('錯誤', '請填寫申請人年資！', true, () => {
        }, () => {
        });
        return false;
      }
      if (this.editedItem.company.address === '') {
        this.showMessageDialog('錯誤', '請填寫公司地址！', true, () => {
        }, () => {
        });
        return false;
      }
      return true;
    },

  },
};
</script>
<style scoped src="../../assets/css/finatrade_edit.css">
</style>
<style scoped>
.btn {
  text-align: center;
}
.btn a {
  display: inline-block;
  text-decoration: none;
  border: 1px solid #2b7fa5;
  background: #c2dfec;
  text-align: center;
  line-height: 30px;
  padding: 0 20px;
  font-size: 16px;
  margin: 0 auto 100px;
  border-radius: 5px;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
  color: #10455d;
}
.btn a:hover {
  background: #189ad4;
  color: #fff;
}
.signbox {
  position: absolute;
  margin-left:10px;
  width: 125px; height: 30px;
}
</style>



// WEBPACK FOOTER //
// src/pages/web/FinatradeEditView.vue